import "core-js/modules/es6.math.log10";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import Measure from 'react-measure';
import React from 'react';
import styled from 'styled-components';
import { AnyColor, AnyColor as TextColor } from '../../../types/color';
import { getOffset } from './getOffset';
import { Size } from './types';
import { styledFactory } from '../../../utilities/styled-components';
import { Text } from '../../typography/Text';
var Color = AnyColor;

var Badge =
/** @class */
function (_super) {
  __extends(Badge, _super);

  function Badge(props) {
    var _this = _super.call(this, props) || this;

    _this.getMeasuredContent = _this.getMeasuredContent.bind(_this);
    return _this;
  }

  Badge.prototype.getMeasuredContent = function (_a) {
    var contentRect = _a.contentRect,
        measureRef = _a.measureRef;
    var _b = this.props,
        backgroundColor = _b.backgroundColor,
        children = _b.children,
        id = _b.id,
        maxDigits = _b.maxDigits,
        size = _b.size,
        target = _b.target,
        textColor = _b.textColor,
        xOffset = _b.xOffset,
        yOffset = _b.yOffset,
        dot = _b.dot,
        outline = _b.outline,
        outlineColor = _b.outlineColor,
        hideIfZero = _b.hideIfZero;
    var text = typeof children === 'number' ? Math.log10(children) > maxDigits ? Math.pow(10, maxDigits) - 1 + '+' : Math.floor(children) : children;
    var textSize;

    switch (size) {
      case Size.Sm:
        textSize = -1;
        break;

      case Size.Md:
        textSize = 0;
        break;
    }

    var shouldShow = !(hideIfZero && text === 0);

    if (!contentRect.bounds) {
      return null;
    }

    var _c = contentRect.bounds,
        width = _c.width,
        height = _c.height;
    var rightOffset = getOffset(xOffset, width);
    var topOffset = getOffset(yOffset, height);
    return React.createElement(Wrapper, {
      ref: measureRef
    }, shouldShow ? React.createElement(StyledBadge, {
      "aria-hidden": true,
      backgroundColor: backgroundColor,
      badgeOnTarget: !!target,
      dot: dot,
      id: id,
      outline: outline,
      outlineColor: outlineColor,
      right: rightOffset,
      top: topOffset
    }, dot ? React.createElement(Dot, null) : React.createElement(Text, {
      color: textColor,
      el: Text.Element.Div,
      noSelect: true,
      size: textSize,
      weight: Text.Weight.Bold
    }, text)) : React.createElement("span", null), target);
  };

  Badge.prototype.render = function () {
    return React.createElement(Measure, {
      bounds: true
    }, this.getMeasuredContent);
  };

  Badge.Size = Size;
  Badge.BackgroundColor = Color;
  Badge.OutlineColor = Color;
  Badge.TextColor = TextColor;
  Badge.defaultProps = {
    backgroundColor: Color.Primary,
    hideIfZero: false,
    maxDigits: 2,
    outlineColor: Color.Light,
    size: Size.Sm,
    target: null,
    textColor: Color.Light
  };
  return Badge;
}(React.Component);

export { Badge };

var getColor = function getColor(color, theme) {
  return theme.colors[color] || color;
};

export var Wrapper = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-flex;\n    position: relative;\n"], ["\n    display: inline-flex;\n    position: relative;\n"])));
var Dot = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    height: ", ";\n    width: ", ";\n"], ["\n    height: ", ";\n    width: ", ";\n"])), function (props) {
  return props.theme.units.getValue(0.75);
}, function (props) {
  return props.theme.units.getValue(0.75);
});
Dot.displayName = 'Dot';
export var StyledBadge = styledFactory(styled.span)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background-color: ", ";\n    ", "\n    ", "\n    display: inline-flex;\n    ", "\n    border-radius: ", ";\n    pointer-events: none;\n    z-index: ", ";\n    ", "\n    ", "\n"], ["\n    background-color: ", ";\n    ", "\n    ", "\n    display: inline-flex;\n    ", "\n    border-radius: ", ";\n    pointer-events: none;\n    z-index: ", ";\n    ", "\n    ", "\n"])), function (props) {
  return getColor(props.backgroundColor, props.theme);
}, function (props) {
  return props.right && "right: " + props.right + ";";
}, function (props) {
  return props.top && "top: " + props.top + ";";
}, function (props) {
  return props.dot ? '' : "padding: 0 " + props.theme.units.getValue(0.5) + ";";
}, function (props) {
  return props.dot ? props.theme.cornerRadii.circle : props.theme.components.badge.cornerRadii;
}, function (props) {
  return props.theme.zIndex.Z_INDEX_1;
}, function (props) {
  return props.badgeOnTarget ? 'position: absolute;' : '';
}, function (props) {
  return props.outline ? "border: 2px solid " + getColor(props.outlineColor, props.theme) : '';
});
StyledBadge.displayName = 'StyledBadge';
var templateObject_1, templateObject_2, templateObject_3;